import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { ReadonlyStateKey } from 'layout/MainLayout/components/Sidebar/components/components/StudentSection/types';
import { OPENED_CONTENT_WIDTH } from 'layout/MainLayout/components/Sidebar/constants';
import { SidebarStateKey } from 'layout/MainLayout/components/Sidebar/store';
import {
  openedMixin,
  closedMixin,
} from 'layout/MainLayout/components/Sidebar/utils';

import type { StudentSectionReadonlyState } from 'layout/MainLayout/components/Sidebar/components/components/StudentSection/types';
import type { SidebarAnimatedComponentsState } from 'layout/MainLayout/components/Sidebar/types';

export const Wrapper = styled(Box, {
  shouldForwardProp: prop =>
    prop !== SidebarStateKey.Opened && prop !== ReadonlyStateKey.Readonly,
})<SidebarAnimatedComponentsState & StudentSectionReadonlyState>(
  ({ theme, opened = false, readonly = false }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: OPENED_CONTENT_WIDTH,
    margin: theme.spacing(6.5, 'auto', 4),
    overflow: 'hidden',
    gap: opened ? theme.spacing(2) : 0,
    pointerEvents: readonly ? 'none' : 'auto',
    cursor: readonly ? 'auto' : 'pointer',

    [theme.breakpoints.up('md')]: {
      ...(opened && {
        ...openedMixin({ theme }),
      }),
      ...(!opened && {
        margin: theme.spacing(6.75, 'auto', 4),
        maxWidth: 40,
        ...closedMixin({ theme }),
      }),
    },
  }),
);
